<template>
  <v-dialog
    v-model="showModal"
    persistent
  >
    <v-card
      class="card-style"
      color="#ECEFF1"

      :style="getBgStyle"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-cellphone-key
        </v-icon> Sign In
      </h2>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-card-text class="justify-center">
          <v-container fluid>
            <p
              v-if="!changeNumber"
              class="welcome-title"
            >
              Welcome <br><font style="color:#37474F;">
                {{ mobileNumber }}
              </font> <br>
              <font class="number-change">
                Another account ? <span
                  class="span-style"
                  @click="changeAccount()"
                > Click  </span>here
              </font>
            </p>
            <v-text-field
              v-if="changeNumber"
              v-model="mobileNumber"
              label="Mobile Number*"
              outlined
              :rules="[(v) => !!v || 'This field is required']"
              color="#000000"
              type="number"
              inputmode="numeric"
              dense
              filled
              light
            />
            <p class="passcode-title">
              Enter Your Passcode
            </p>
            <div
              class="otp-style"
              style="max-width: 200px"
            >
              <v-otp-input
                v-model="passcode"
                type="password"
                :rules="[(v) => !!v || 'This field is required']"
                length="4"
                inputmode="numeric"
                light
                filled
                color="#000000"
              />
              <p
                class="password-reset"
                @click="resetCode()"
              >
                Forgot Passcode?
              </p>
            </div>
            <v-card-actions>
              <v-spacer />
              <v-btn
                class="mt-2"
                color="#37474F"
                @click="showModal = false"
              >
                Cancel
              </v-btn>
              <v-btn
                class="mt-2"
                color="#FF3700"
                @click="signIn()"
              >
                Sign In
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
import Constants from 'src/constants';
import spinner from 'src/views/components/SpinnerCentre';
import axios from '@/app-axios';

export default {
  name: 'Login',
  components: {
    'centre-spinner': spinner,
  },
  props: {
    siteId: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      showModal: true,
      loading: false,
      mobileNumber: null,
      passcode: '',
      valid: false,
      cardBgImg: require('@/assets/img/cardBg.png'),
      changeNumber: false,
    };
  },
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  mounted () {
    this.loading = true;
    this.loadOnMount();
    this.loading = false;
  },
  methods: {
    loadOnMount () {
      const previousSignedInNumber = localStorage.getItem('previousSignedInAccount');
      if (previousSignedInNumber !== null) {
        this.changeNumber = false;
        this.mobileNumber = previousSignedInNumber;
        return;
      }
      this.changeNumber = true;
    },
    signIn () {
      if (this.passcode.length < 4 || this.mobileNumber === null) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please enter the credentials before proceeding.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      axios.get('sanctum/csrf-cookie').then(response => {
        this.$store
          .dispatch('login', {
            phone_number: this.mobileNumber,
            password: this.passcode,
            site_id: this.siteId,
          })
          .then(response => {
            this.loading = false;
            localStorage.removeItem('previousSignedInAccount');
            localStorage.setItem('previousSignedInAccount', this.mobileNumber);
            this.$emit('login-completed');
            this.showModal = false;
          })
          .catch(() => {
            this.$store.dispatch('alert/onAlert', {
              message: 'These credentials do not match our records.',
              type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            this.loading = false;
          });
      });
    },
    changeAccount () {
      this.changeNumber = true;
    },
    resetCode () {
      this.$router.push(`/passcode/reset/${this.siteId}`);
    },
  },
};
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.card-style {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.otp-style {
  margin: auto;
  margin-bottom: 10px;
}
.passcode-title {
  font-size: 18px;
  font-weight: bold;
  color: #37474F;
  text-align: center;
  margin-bottom: 15px;
  font-family:'Times New Roman', Times, serif;
}
.welcome-title {
  font-size: 25px;
  font-weight: bold;
  color: #FF3700;
  margin-bottom: 15px;
  font-family:'Times New Roman', Times, serif;
  line-height: 1.2;
}
.span-style {
  font-family: 'Times New Roman', Times, serif;
  color: #FF3700;
}
.number-change {
  font-family: 'Times New Roman', Times, serif;
  color: #546E7A;
  font-size: 16px;
}
.password-reset {
  color: #FF3700;
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
  font-size: 15px;
  text-decoration: underline;
}
</style>
